module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-logs"
  }, [_vm._m(0), _c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('accordion', _vm._l((_vm.items), function(l) {
    return _c('accordion-item', {
      attrs: {
        "title": _vm.$dateFormat(l.date.date, "DD-MM-YYYY HH:mm:ss") + ' | ' + l.action
      }
    }, [_c('log', {
      attrs: {
        "item": l
      }
    })], 1)
  }), 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('h2', [_vm._v("Logs")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c601d4d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleSlotLogs.vue
// module id = 2309
// module chunks = 1